<template>
  <div>
    <PageTitle :route="$route">
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ActiveMovementBatch />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
  import PageTitle from '@/components/layout/PageTitle'
  import PageRowWrapper from '@/components/layout/PageRowWrapper'
  import ActiveMovementBatch from '@/components/activesmovementbatch/ActiveMovementBatch'

  export default {
    name: 'ActiveMovement',
    components: {
      PageTitle,
      PageRowWrapper,
      ActiveMovementBatch
    }
  }
</script>
